import { string, boolean, object } from 'yup';

import dayjs from 'dayjs';
import { regex } from './utils';
import { constants } from '../../../utils/constants';
import { ValidateFieldPhoneProps } from '../../../utils/types';
import { removeWhitespace } from '../../../utils';

export const validationSchemaDefault = (hasModelIssueDate: boolean) =>
    object({
        birthCountry: string().required(constants.REQUIRED_FIELD).nullable(),
        idCardCountry: string().required(constants.REQUIRED_FIELD).nullable(),
        issuer: string().required(constants.REQUIRED_FIELD).min(2, 'Délka pole musí mít alespoň 2 znaky').nullable(),
        citizenship: string().required(constants.REQUIRED_FIELD).nullable(),
        validateSecondCitizenship: boolean(),
        secondCitizenship: string()
            .when('validateSecondCitizenship', {
                is: true,
                then: (schema) => schema.required(constants.REQUIRED_FIELD).nullable(),
            })
            .nullable(),
        birthPlace: string().required(constants.REQUIRED_FIELD).nullable(),
        bankAccountNo: string().required(constants.REQUIRED_FIELD),
        bankAccountCode: string().required(constants.REQUIRED_FIELD),
        email: string().email(constants.EMAIL_FIELD).required(constants.REQUIRED_FIELD),
        phone: string().required(constants.REQUIRED_FIELD),
        issueDate: hasModelIssueDate
            ? string().notRequired()
            : string()
                  .test('yearValidation', constants.REQUIRED_VALID_DATE_FIELD, (_, meta) => {
                      const yearString = meta.originalValue.toString().split(' ')[3];

                      const bottomThreshold = 2000;

                      return !(Number(yearString) < bottomThreshold) && !(Number(yearString).toString().length < 4);
                  })
                  .test('issueDateOverlap', constants.ISSUE_DATE_GT_TODAY, (value) => {
                      return !dayjs(value).isAfter(new Date());
                  }),
    });

export const getPhoneValidationRegex = (prefix: string): string => {
    switch (prefix) {
        case '+420':
            return regex.CZECH_CELLPHONE_REGEX;
        case '+421':
            return regex.SLOVAK_CELLPHONE_REGEX;
        case '+48':
            return regex.POLAND_CELLPHONE_REGEX;
        default:
            return regex.OTHER_CELLPHONE_REGEX;
    }
};

export const validateFieldPhone = ({ phone, phonePrefix, optional }: ValidateFieldPhoneProps): string | null => {
    if ((!phone || !phonePrefix) && !optional) {
        return constants.REQUIRED_FIELD;
    }

    const regex = new RegExp(getPhoneValidationRegex(phonePrefix));
    if (phone && !regex.test(removeWhitespace(phone) || '') && !optional) {
        return constants.CELLPHONE_NUMBER;
    }

    return null;
};
